import { RetrievedIdCard } from 'front-office/view-models/retrieve-id-card/retrieved-id-card';
import { Fragment } from 'react';
import { PmiBodyTableCell } from 'shell/components/shared/table-custom/body';
import { PmiTableRow } from 'shell/components/shared/table/row';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton } from '@mui/material';

interface TableRowComponentProps {
  retrievedCard: RetrievedIdCard;
  onTrashPress: (card: RetrievedIdCard) => void;
}

const TableRowComponent = ({
  retrievedCard,
  onTrashPress,
}: TableRowComponentProps): React.ReactElement => {
  return (
    <Fragment>
      <PmiTableRow>
        <PmiBodyTableCell scope="row">
          <pre
            style={{
              overflow: 'auto',
              maxHeight: '100px',
            }}
          >
            {retrievedCard.xmlText}
          </pre>
        </PmiBodyTableCell>
        <PmiBodyTableCell scope="row">
          <IconButton
            color="error"
            aria-label="remove anomaly"
            component="span"
            onClick={() => onTrashPress(retrievedCard)}
          >
            <DeleteIcon />
          </IconButton>
        </PmiBodyTableCell>
      </PmiTableRow>
    </Fragment>
  );
};

TableRowComponent.displayName = 'Table row component';

export default TableRowComponent;
